import {
  useGetIdentity,
  useGetList,
  useListContext,
  useResourceContext,
  useTranslate,
} from "ra-core";
import { List } from "@/components/admin/list";

import { MobileContent } from "../layout/MobileContent";
import MobileHeader from "../layout/MobileHeader";
import type { OutreachList, OutreachListMember } from "../types";
import { OutreachListCard } from "./OutreachListCard";

export const OutreachListListMobile = () => {
  const { identity } = useGetIdentity();
  if (!identity) return null;
  return (
    <List
      title={false}
      perPage={25}
      sort={{ field: "name", order: "ASC" }}
      actions={false}
      pagination={false}
    >
      <OutreachListListMobileLayout />
    </List>
  );
};

const OutreachListListMobileLayout = () => {
  const { data, isPending } = useListContext<OutreachList>();
  const translate = useTranslate();
  const resource = useResourceContext();
  const { data: activeMembers } = useGetList<OutreachListMember>(
    "outreach_list_members",
    {
      filter: { "removed_at@is": null },
      pagination: { page: 1, perPage: 1000 },
      sort: { field: "id", order: "ASC" },
    },
  );

  if (isPending) return null;

  const countsByList = (activeMembers ?? []).reduce<Record<string, number>>(
    (acc, member) => {
      const key = String(member.list_id);
      acc[key] = (acc[key] ?? 0) + 1;
      return acc;
    },
    {},
  );

  return (
    <>
      <MobileHeader>
        <h1 className="text-xl font-semibold">
          {translate(`resources.${resource}.name`, {
            smart_count: 2,
            _: resource === "channels" ? "Channels" : "Offer",
          })}
        </h1>
      </MobileHeader>
      <MobileContent>
        <div className="flex flex-col gap-3">
          {data?.map((list) => (
            <OutreachListCard
              key={list.id}
              list={list}
              activeCount={countsByList[String(list.id)] ?? 0}
            />
          ))}
        </div>
      </MobileContent>
    </>
  );
};
